import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_5 = {
  key: 2,
  class: "bg-white border border-gray-200 shadow-sm rounded-xl p-6"
}
const _hoisted_6 = { class: "grid gap-6 md:grid-cols-2" }
const _hoisted_7 = { class: "md:col-span-2" }
const _hoisted_8 = { class: "mt-6 flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mb-6" }, [
        _createElementVNode("h1", { class: "text-3xl font-semibold text-gray-900" }, " Edit Announcement "),
        _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, " Update the announcement for members. ")
      ], -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading announcement... "))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateAnnouncement && _ctx.updateAnnouncement(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Title", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      required: "",
                      type: "text"
                    }, null, 512), [
                      [_vModelText, _ctx.form.title]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Message", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.body) = $event)),
                      class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                      rows: "4",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.form.body]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("button", {
                    class: "inline-flex items-center rounded-lg bg-black px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800",
                    type: "submit"
                  }, " Save Changes ", -1)),
                  _createVNode(_component_router_link, {
                    class: "text-sm font-medium text-gray-600 hover:text-gray-900",
                    to: "/administrator/announcements"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode(" Cancel ")
                    ])),
                    _: 1
                  })
                ])
              ], 32)
            ]))
    ])
  ]))
}